import axios from "axios";

export const uploadImage = async (files) => {
  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const data = await axios.post(
      `${process.env.REACT_APP_URL}/api/order/upload-order-image`,
      files,
      config
    );
    return data?.data?.result;
  } catch (error) {
    console.log(error);
    return error?.response?.data?.result;
  }
};

export const uploadQcImages = async (files, qcDetailsId) => {
  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const data = await axios.post(
      `${process.env.REACT_APP_URL}/api/qc/upload-qc-images?qc_details_id=${qcDetailsId}`,
      files,
      config
    );
    return data?.data?.result;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getQcImages = async (qcDetailsId) => {
  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/qc/get-qc-images?qc_details_id=${qcDetailsId}`,
      config
    );
    return data?.data?.result;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteQcImage = async (qcDetailsId, imagePath) => {
  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const data = await axios.post(
      `${process.env.REACT_APP_URL}/api/qc/delete-qc-image`,
      { qc_details_id: qcDetailsId, image_path: imagePath },
      config
    );
    return data?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
